<template>
  <div>
    <div id="target" class="yjxx">
    <el-row class='main-body' id="yjxx">
      <el-col style="text-align: left;" :span="16" :offset="4">
        <el-row>
          <el-col style="text-align: left">
            <h2  class="info-main"  style="font-size: 25px;">{{ $t('default.yjxx') }}</h2>
            <p class="info-p">
            <a href="http://redlight-realworld.com/public/infosheet0420.pdf" download="http://redlight-realworld.com/public/infosheet0420.pdf">{{ $t('default.yjxxdl') }}</a>
            </p>
            <p class="info-p" >
            <a href="http://redlight-realworld.com/public/information_sheet_RLRL RWS0417-yxc.pdf" download="http://redlight-realworld.com/public/information_sheet_RLRL RWS0417-yxc.pdf">{{ $t('default.yjxxdl_en') }}</a>

            </p>
            <p class="info-p">
            <a href="http://redlight-realworld.com/public/consent_form_RLRL RWS1221.pdf" download="http://redlight-realworld.com/public/consent_form_RLRL RWS1221.pdf">{{ $t('default.inform') }}</a>
            </p>
            <p class="info-p">
            <a href="http://redlight-realworld.com/public/EDC.pdf" download="http://redlight-realworld.com/public/EDC.pdf">{{ $t('default.edc_text') }}</a>
            </p>
            <p class="info-p">
            <a href="http://redlight-realworld.com/public/Instructions.pdf" download="http://redlight-realworld.com/public/Instructions.pdf">{{ $t('default.edc_en_text') }}</a>
            </p>
            <p class="info-p">{{ $t('default.edc_video') }}
              <a style="display: inline-block;margin: 0 20px;" href="https://v.youku.com/v_show/id_XNjQxNDExMTgwNA==.html">{{ $t('default.whatchOnline') }}
              </a>
              <a href="http://redlight-realworld.com/public/MP4.mp4" download="http://redlight-realworld.com/public/MP4.mp4">{{ $t('default.Download') }}
              </a>
            </p>
            <p class="info-p">
              {{ $t('default.edc_en_video') }}

              <a style="display: inline-block;margin: 0 20px;" href="https://youtu.be/kTVTXh-On64">{{ $t('default.whatchOnline') }}
              </a>
              <a href="http://redlight-realworld.com/public/instructions.mp4" download="http://redlight-realworld.com/public/instructions.mp4">{{ $t('default.Download') }}
              </a>
            </p>
            <p class="info-p">
              {{ $t('default.yjxx_foot') }}
            </p>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  components: {
  },
  data() {
    return {
    }
  },
}
</script>
<style lang="less">
.yjxx {
  background-image: linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.5)), url('../../assets/banner1.jpg');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  padding-top: 50px;
  .info-main {
    display: inline-block;
    font-weight: 800;
    margin-bottom: 30px;
    font-style: normal;
    color: #111827;
    font-size: 30px;
    line-height: 38px;
  }
  .info-title {
    font-weight: 800;
    background: #111827;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-right: .2rem;
    padding-bottom: .4rem;
    -webkit-box-decoration-break: clone;
  }
  .info-p {
    font-size: 16px;
    line-height: 30px;
    color: #000;
    display: block;
  }
}
</style>